import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface ZusatztoolsZertifizierungInfoAlternatSystemProps {
    data: any;
}

export class ZusatztoolsZertifizierungInfoAlternatSystem extends React.Component<ZusatztoolsZertifizierungInfoAlternatSystemProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ margin: 10 }}>
                {renderText('Alternatives System - Info', this.props.data)}
            </div>
        );
    }
}
